<template>
  <div class="create-analyzer-sources">
    <div class="header">
      <h2>Select Training Data</h2>
    </div>

    <div class="options" v-if="!openedSourceTab">
      <div :class="['card','card-action']" @click="openedSourceTab = 'documents'">
        <h3>Documents</h3>
        <p class="detail">Select AI trainings data by uploading PDF-documents</p>
        <p class="detail">Total tokens: {{ totalDocumentsTokens }}</p>
      </div>

      <div :class="['card','card-action']" @click="openedSourceTab = 'websites'">
        <h3>Websites</h3>
        <p class="detail">Select AI trainings data by providing URL's from websites.</p>
        <p class="detail">Total tokens: {{ totalWebsitesTokens }}</p>
      </div>

      <div :class="['card','card-action', 'disabled']">
        <h3>Plain Text</h3>
        <p class="detail">Provide AI trainings data by pasting plain text.</p>
        <p class="detail">Total tokens: {{ totalPlainTextTokens }}</p>

        <div class="selected-label">Not Available Yet</div>
      </div>
    </div>

    <div class="source-options" v-else-if="openedSourceTab === 'documents'">
      <div class="source-header">
        <h3>Selected Documents</h3>
      </div>
      <div class="documents">
        <div v-if="uploading" style="display: flex;justify-content: center">
          <loader></loader>
        </div>

        <div v-else-if="dataSources.documents.length === 0">
          <p class="detail">No documents uploaded yet.</p>
        </div>

        <div :class="['document', uploading ? 'document-uploading' : '']" v-for="document in dataSources.documents" :key="document.id">
          <svg class="document-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 50 50">
            <path d="M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z M 15 22 L 15 24 L 35 24 L 35 22 Z M 15 28 L 15 30 L 31 30 L 31 28 Z M 15 34 L 15 36 L 35 36 L 35 34 Z"></path>
          </svg>
          <h4>{{ document.name }}</h4>
          <p class="detail">{{ document.type }}</p>
          <p class="detail">{{ document.tokens }} tokens</p>
        </div>
      </div>
      <div class="upload-document">
        <div class="upload-document" v-if="!uploading">
            <input type="file" id="file-input" accept=".pdf" multiple hidden @change="onFileChange">
          <label for="file-input" class="file-input-label">
            <span>Upload a file</span>
          </label>
        </div>
      </div>
    </div>


    <div class="source-options" v-else-if="openedSourceTab === 'websites'">
      <div class="source-header">
        <h3>Websites</h3>
      </div>

      <div class="documents">
        <div v-if="dataSources.websites.length === 0">
          <button @click="addUrl">Add Website</button>
        </div>
        <div v-if="processing" style="display: flex;justify-content: center">
          <loader></loader>
        </div>
        <div v-else>
          <div class="document" v-for="(website, index) in dataSources.websites" :key="index" :style="[website.processed ? { backgroundColor: '#cadfca' } : {}]">
            <svg class="document-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 50 50">
              <path d="M 7 2 L 7 48 L 43 48 L 43 14.59375 L 42.71875 14.28125 L 30.71875 2.28125 L 30.40625 2 Z M 9 4 L 29 4 L 29 16 L 41 16 L 41 46 L 9 46 Z M 31 5.4375 L 39.5625 14 L 31 14 Z M 15 22 L 15 24 L 35 24 L 35 22 Z M 15 28 L 15 30 L 31 30 L 31 28 Z M 15 34 L 15 36 L 35 36 L 35 34 Z"></path>
            </svg>
            <span class="remove-document" @click="dataSources.websites.splice(index, 1)">X</span>
            <p class="detail">
              <input type="text" v-model="website.url" placeholder="https://website.com" style="width: 80%;font-size: 12px;" />
            </p>
            <p class="detail">
              <input type="checkbox" v-model="website.followInternal" /> Follow internal domains
            </p>
            <p class="detail">
              <input type="checkbox" v-model="website.followExternal" disabled/> Follow external domains (not available yet)
            </p>
            <p class="detail" v-if="website.processed">Tokens: {{ website.tokens }}</p>
            <p class="detail" v-if="website.processed">Visited links: {{ website.visitedLinks.join(', ') }}</p>
          </div>
        </div>
      </div>
      <div style="display:flex; margin-top: 10px;">
        <button @click="process" :disabled="dataSources.websites.length === 0 || processing || dataSources.websites.every(website => website.processed)">Process</button>
      </div>

    </div>

    <div class="source-options" v-else-if="openedSourceTab === 'plain_text'">
      <div class="source-header">
        <h3>Plain Text</h3>
      </div>
      <textarea v-model="dataSources.plainText" style="width: 400px; height: 300px; padding: 10px; font-size: 12px;"></textarea>
      <div style="display:flex; margin-top: 10px;">
        <button @click="save" style="background-color: black; color:white">Save</button>
      </div>
    </div>

    <div class="next" v-if="!openedSourceTab">
      <button class="empty" @click="$router.push('/models/create/models_type')">Back</button>
      <button :disabled="!canContinue" @click="next">Next</button>
    </div>
    <div class="next" v-else>
      <button class="empty" :disabled="uploading || processing || dataSources.websites.some(website => !website.processed)" @click="openedSourceTab = null">Back</button>
      <button :disabled="uploading || processing || dataSources.websites.some(website => !website.processed)" @click="openedSourceTab = null">Done</button>
    </div>
    
  </div>
</template>

<script>
import config from '../../config';
import Loader from '../Loader.vue';

export default {
  name: 'AnalyzerSources',
  props: {
    analyzer: Object
  },
  components: {
    Loader
  },
  data () {
    return {
      openedSourceTab: null,
      dataSources: {
        documents: [],
        websites: [],
        plainText: ''
      },
      uploading: false,
      processing: false
    }
  },
  methods: {
    validateUrls() {
      const invalidUrls = this.dataSources.websites.filter(website => !this.isValidUrl(website.url));
      if (invalidUrls.length > 0) {
        this.notificationController.addNotification({ type: 'error', title: 'Invalid website URL(s)', message: ('Invalid URLs: ' + invalidUrls.map(website => website.url).join(', ')), duration: 3000 });
        return false;
      }

      return true;
    },
    isValidUrl(url) {
      const pattern = new RegExp('^https?:\\/\\/'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
      return pattern.test(url);
    },
    process() {
      if (!this.validateUrls())
        return;
      if (this.dataSources.websites.length === 0) {
        this.notificationController.addNotification({ type: 'error', title: 'No websites', message: 'No websites to process.', duration: 3000 });
        return;
      }

      this.notificationController.addNotification({ type: 'info', title: 'Processing websites', message: 'Processing websites, this may take a while...', duration: 5000 });

      this.processing = true;

      const token = localStorage.getItem('token');

      fetch(config.api + '/sources/process_websites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({
          websites: this.dataSources.websites.map(website => ({
            id: website.id,
            visited_links: website.visitedLinks,
            tokens_amount: website.tokens,
            url: website.url,
            follow_internal: website.followInternal,
            follow_external: website.followExternal,
          }))
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((result) => {
        this.dataSources.websites = this.dataSources.websites.map(website => {
          website.processed = true;
          website.tokens = result.tokens_amount;
          website.id = result.id;
          website.visitedLinks = result.visited_links;
          return website;
        });
      })
      .catch(error => {
        if (error.message === '403') {
          this.$router.push('/login');
          return;
        }
        
        this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: "Websites could not be processed.", duration: 3000 });
        console.error(error);
      })
      .finally(() => {
        this.processing = false;
      });
    },
    addUrl () {
      this.dataSources.websites.push({ id: "", url: '', followInternal: false, followExternal: false, processed: false, tokens: 0, visitedLinks: [] });
    },
    async onFileChange(e) {

      try {
        this.uploading = true;

        const files = e.target.files;

        this.notificationController.addNotification({ type: 'info', title: 'Uploading documents', message: 'Uploading documents, this may take a while...', duration: 5000 });
        
        for (let i = 0; i < files.length; i++) {
          await this.uploadFile(files[i]);
        }

        this.uploading = false;
      } catch (error) {
        console.error(error.message)
      }
    },
    async uploadFile(file) {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token');

        const formData = new FormData();
        formData.append('file', file);

        fetch(config.api + '/sources/upload', {
          method: 'POST',
          body: formData,
          headers: {
            'Authorization': 'Bearer ' + token
          }
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(response.status);
          }
          return response.json();
        })
        .then(({ id, name, type, tokens_amount }) => {
          this.dataSources.documents.push({ id, name, type, tokens: tokens_amount });

          this.$emit('update', {
            dataSources: this.dataSources
          });

          resolve();
        })
        .catch(error => {
          if (error.message === '403') {
            this.$router.push('/login');
            return;
          }
          
          this.notificationController.addNotification({ type: 'error', title: 'Internal error', message: "Could not upload document(s).", duration: 3000 });
          console.error(error);
          reject();
        });
      })
    },
    next () {
      this.$router.push('/models/create/models_summary');
    }
  },
  computed: {
    totalDocumentsTokens () {
      return this.analyzer.dataSources.documents.reduce((acc, doc) => acc + doc.tokens, 0);
    },
    totalWebsitesTokens () {
      return this.analyzer.dataSources.websites.reduce((acc, doc) => acc + doc.tokens, 0);
    },
    totalPlainTextTokens () {
      return this.analyzer.dataSources.plainText.length;
    },
    canContinue () {
      return this.totalDocumentsTokens > 0 || this.totalWebsitesTokens > 0 || this.totalPlainTextTokens > 0;
    }
  },
  created () {
    this.dataSources = this.analyzer.dataSources;
  }
}
</script>

<style scoped>

.source-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 400px;
}

.source-options {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.documents {
  width: 400px;
  padding: 20px 0;
  height: 300px;
  overflow-y: scroll;
}

.document {
  border-left: 1px solid rgb(159, 159, 159);
  padding: 4px 0 4px 30px;
  margin: 0 0 10px 0;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  transition: 200ms;
  position: relative;
}

.remove-document {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}



.document:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transition: 200ms;
}

.back-button {
  background-color: transparent;
  color: rgb(221, 221, 221);
  color: black;
  padding: 0 10px;
  transition: 200ms;
}

.back-button:hover {
  background-color: rgb(201, 201, 201);
  color: rgb(0, 0, 0);
  transition: 200ms;
}

.document-icon {
  position: absolute;
  top: 15px;
  left: 4px;
}

.file-input-label {
  display: inline-block;
  padding: 4px 20px;
  background-color: transparent;
  color: black;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  transition: 200ms;
}

.file-input-label:hover {
  background-color: #dddddd;
  transition: 200ms;
}

.document-uploading {
  opacity: .3;
  transition: 200ms;
}

</style>



// WEBPACK FOOTER //
// src/components/CreateModelFlow/AnalyzerSources.vue